export default "__VITE_ASSET__D5A1_ZQ4__"